export default __webpack_public_path__ + "static/media/PTP.675d0aaf.png";